import Security from '@/_helpers/security.js';
import Vue from 'vue';
import VueRouter from 'vue-router';

import { load_script, updateZendeskLocale } from '@/_helpers/utils.js';

// TODO общие роуты https://www.wrike.com/workspace.htm?acc=1741102

// роуты приватные - под авторизацией
import inner from './inner/index.vue';
import innerRoutes from './inner/routes.js';
// роуты публичные - без авторизации
import outer from './outer/index.vue';
import outerRoutes from './outer/routes.js';

import VcvNotFound from '@/routes_new/outer/components/VcvNotFound';

Vue.use(VueRouter);

const router = new VueRouter({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: { name: 'responses' }
    },
    {
      path: '',
      component: outer,
      beforeEnter: Security.notRequireAuth,
      children: outerRoutes
    },
    {
      path: '',
      component: inner,
      beforeEnter: Security.requireAuth,
      children: innerRoutes
    },
    // {
    //   path: '*',
    //   redirect: { name: 'responses' }
    // }
    {
      path: '*',
      name: 'vcv-not-found',
      component: VcvNotFound
    }
  ]
});

function get_current_domain() {
  const host = window.location.hostname;
  let domain;

  if (host) {
    const hostSplitArray = host.split('.');
    domain = hostSplitArray[hostSplitArray.length - 1];

    if (domain !== 'ru' && domain !== 'ai') {
      domain = 'ru';
    }
  } else {
    domain = 'ru';
  }

  return domain;
}

const domain = get_current_domain();
window.Vue = Vue;
const zendeskRoutes = ['/tests', '/record', '/online', '/survey', '/talentq', '/interviews', '/r/'];

router.afterEach(to => {
  if (window && !window.zE && domain !== 'ai') {
    let include = false;

    zendeskRoutes.forEach(item => {
      if (to.path.indexOf(item) === 0) {
        include = true;
      }
    });

    if (!include) {
      return;
    }

    setTimeout(() => {
      load_script(
        'https://static.zdassets.com/ekr/snippet.js?key=20cb4594-9194-463b-9a98-70f35015bc71',
        'ze-snippet',
        () => {
          updateZendeskLocale();
        },
        'async'
      );
    }, 100);
  }

  if (!window.zE) {
    return;
  }

  if (to.path.indexOf('/admin') === 0 || to.name === 'login') {
    if (window.zE.hide) {
      window.zE.hide();
    }
  } else {
    if (window.zE.show) {
      window.zE.show();
    }
  }
});

export default router;
